module.exports = __webpack_public_path__ + "static/media/Triangle.38c61ee2.svg";